import { IInduccionResultadoModel, IInduccionResultadosModel } from "../interfaces/induccion/IInduccionResultadoModel";

export class InduccionResultadoModel implements IInduccionResultadoModel {
    idInduccion: number;
    aprobado: boolean;
    desaprobado: boolean;

    constructor(){
        this.idInduccion = 0;
        this.aprobado = false;
        this.desaprobado = false;        
    }
}

export class InduccionResultadosModel implements IInduccionResultadosModel {
    listaInducciones: InduccionResultadoModel[];
    nombresCapacitador: string;
    gidCapacitador: string;

    constructor(){
        this.listaInducciones = new Array<InduccionResultadoModel>();
        this.nombresCapacitador = '';
        this.gidCapacitador = '';
    }
}